import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Table } from "reactstrap";
import { str2bool } from "../../helpers/utils.js";
import i18next from "i18next";

const TableProfessionalHouseManagerCompanies = (props) => {
  const [state, setState] = useState({});

  const handleDataChange = (event) => {
    const value = event.target.value;

    setState((state) => ({
      ...state,
      [event.target.name]: value,
    }));

    props.data[event.target.name] = value;
  };

  const handleEdit = () => {
    setState((state) => ({ ...state, mode: "edit" }));
  };

  const handleSave = () => {
    setState((state) => ({ ...state, mode: "view" }));
  };

  const toggleActive = (e) => {
    setState((state) => ({ ...state, isActive: str2bool(e.target.value) }));

    props.data.isActive = str2bool(e.target.value);
  };

  useEffect(() => {
    setState((state) => ({ ...state, ...props.data }));
  }, []);

  const radioStyle = {
    listStyle: "none",
    paddingLeft: "0",
  };
  const labelStyle = {
    paddingLeft: "20px",
  };

  const tableStyle = {
    tableLayout: "fixed",
  };

  const { id, name, contactName, contactPhone, email, comment } = props.data;

  return (
    <>
      <div className="table-responsive">
        <Table className="table-nowrap mb-0" style={tableStyle}>
          <tbody>
            <tr>
              <th>{i18next.t("name")}</th>

              <td>
                {props.mode === "edit" ? (
                  <input
                    name="name"
                    placeholder={i18next.t("placeholder_enter_name")}
                    id="phmc_name"
                    onChange={(e) => handleDataChange(e)}
                    defaultValue={name}
                    className="w-100 input-styled"
                  />
                ) : (
                  name
                )}
              </td>
            </tr>

            <tr>
              <th>{i18next.t("contact-person")}</th>

              <td>
                {props.mode === "edit" ? (
                  <input
                    name="contactName"
                    placeholder={i18next.t("placeholder_enter_contact_person")}
                    id="phmc_contact_name"
                    onChange={(e) => handleDataChange(e)}
                    defaultValue={contactName}
                    className="w-100 input-styled"
                  />
                ) : (
                  contactName
                )}
              </td>
            </tr>

            <tr>
              <th>{i18next.t("contactPhone")}</th>

              <td>
                {props.mode === "edit" ? (
                  <input
                    name="contactPhone"
                    placeholder={i18next.t("placeholder_enter_phone")}
                    type="text"
                    id="phmc_contact_phone"
                    onChange={(e) => handleDataChange(e)}
                    defaultValue={contactPhone}
                    className="w-100 input-styled"
                  />
                ) : (
                  contactPhone
                )}
              </td>
            </tr>

            <tr>
              <th>{i18next.t("email")}</th>

              <td>
                {props.mode === "edit" ? (
                  <input
                    name="email"
                    placeholder={i18next.t("placeholder_enter_email")}
                    id="phmc_email"
                    onChange={(e) => handleDataChange(e)}
                    defaultValue={email}
                    className="w-100 input-styled"
                  />
                ) : (
                  email
                )}
              </td>
            </tr>

            <tr>
              <th>{i18next.t("field_comment")}</th>

              <td>
                {props.mode === "edit" ? (
                  <textarea
                    name="comment"
                    placeholder={i18next.t("placeholder_enter_comment")}
                    id="phmc_comment"
                    onChange={(e) => handleDataChange(e)}
                    defaultValue={comment}
                    className="w-100 textarea-styled"
                    maxLength="200"
                  ></textarea>
                ) : (
                  comment
                )}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </>
  );
};

TableProfessionalHouseManagerCompanies.propTypes = {
  userProfile: PropTypes.any,
  onGetUserProfile: PropTypes.func,
};

const mapStateToProps = ({ contacts }) => ({
  userProfile: contacts.userProfile,
});

const mapDispatchToProps = (dispatch) => ({
  onGetUserProfile: () => dispatch(getUserProfile()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(TableProfessionalHouseManagerCompanies));
